module.exports = __webpack_public_path__ + "static/media/leadUpLogo.efeee3dd.jpg";